var _excluded = ["disabled", "edges", "dropzoneLabel", "dropzoneDescription", "placeholder", "onSave", "onDelete", "value", "DropzoneIcon", "hasSelection"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import WarningIcon from '@mui/icons-material/Warning';
import { useDropzone } from 'react-dropzone';
import ActionArea from './ActionArea';
import Confirmation from './Confirmation';
import Modal from './Modal';
import ModalContent from './ModalContent';
import ModalHeader from './ModalHeader';
import Text from './Text';
import AvatarCropDialog from './AvatarCropDialog';
import { StyledAddIcon, StyledAvatar, StyledAvatarIcon, StyledDeleteIcon, StyledCircularProgress, StyledLinearProgress, StyledRoot } from './AvatarInput.styled';
var AvatarInput = function AvatarInput(_ref) {
  var disabled = _ref.disabled,
    edges = _ref.edges,
    dropzoneLabel = _ref.dropzoneLabel,
    dropzoneDescription = _ref.dropzoneDescription,
    placeholder = _ref.placeholder,
    onSave = _ref.onSave,
    onDelete = _ref.onDelete,
    value = _ref.value,
    DropzoneIcon = _ref.DropzoneIcon,
    hasSelection = _ref.hasSelection,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var isNotMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.up('sm');
  });
  var _useState = useState(false),
    confirmDelete = _useState[0],
    setConfirmDelete = _useState[1];
  var _useState2 = useState(null),
    droppedFile = _useState2[0],
    setDroppedFile = _useState2[1];
  var _useState3 = useState(false),
    open = _useState3[0],
    setOpen = _useState3[1];
  var _useState4 = useState(''),
    savedImage = _useState4[0],
    setSavedImage = _useState4[1];
  var _useState5 = useState(false),
    loading = _useState5[0],
    setLoading = _useState5[1];
  var onDrop = function onDrop(acceptedFiles) {
    setLoading(true);
    var reader = new FileReader();
    reader.addEventListener('load', function () {
      setDroppedFile(reader.result);
      setOpen(true);
      setLoading(false);
    });
    reader.readAsDataURL(acceptedFiles[0]);
  };
  var handleSave = function handleSave(result, blob) {
    return onSave(result, blob).then(function () {
      setSavedImage(result);
      setOpen(false);
    })
    // eslint-disable-next-line no-console
    .catch(function (e) {
      return console.error(e);
    });
  };
  var handleDelete = function handleDelete() {
    return onDelete().then(function () {
      setDroppedFile(null);
      setSavedImage('');
      setConfirmDelete(false);
      setOpen(false);
    });
  };
  var _useDropzone = useDropzone({
      onDrop: onDrop,
      disabled: disabled,
      accept: 'image/*',
      maxFiles: 1
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragAccept = _useDropzone.isDragAccept,
    isDragReject = _useDropzone.isDragReject,
    fileRejections = _useDropzone.fileRejections;
  var hasErrors = fileRejections.length > 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(StyledRoot, _extends({
    disabled: disabled,
    edges: edges,
    errors: hasErrors ? 'yes' : ''
  }, getRootProps()), isDragActive && /*#__PURE__*/React.createElement(StyledLinearProgress, {
    isDragReject: isDragReject
  }), loading && !hasErrors && /*#__PURE__*/React.createElement(StyledCircularProgress, null), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 5,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 3,
    md: 2,
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(StyledAvatarIcon, null, function () {
    if (isDragReject) {
      return /*#__PURE__*/React.createElement(WarningIcon, null);
    }
    if (isDragAccept) {
      return /*#__PURE__*/React.createElement(CheckCircleIcon, null);
    }
    if (savedImage || value || placeholder) {
      return /*#__PURE__*/React.createElement(StyledAvatar, {
        src: savedImage || value || placeholder
      });
    }
    if (DropzoneIcon) {
      return /*#__PURE__*/React.createElement(DropzoneIcon, null);
    }
    return /*#__PURE__*/React.createElement(PersonIcon, null);
  }(), !hasSelection && /*#__PURE__*/React.createElement(StyledAddIcon, null, /*#__PURE__*/React.createElement(AddIcon, {
    style: {
      color: 'inherit'
    }
  }))), /*#__PURE__*/React.createElement(Text, {
    align: "center",
    weight: "500",
    color: "textPrimary",
    noWrap: true,
    gutterBottom: false
  }, isDragReject ? 'Error!' : dropzoneLabel)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 8,
    md: 9
  }, /*#__PURE__*/React.createElement(Box, {
    pl: isNotMobile ? 5 : 0
  }, /*#__PURE__*/React.createElement(Text, {
    align: isNotMobile ? 'left' : 'center',
    weight: "500",
    color: "textPrimary"
  }, isDragReject ? 'The selected file(s) will not be accepted' : dropzoneDescription))))), (savedImage || value) && /*#__PURE__*/React.createElement(ActionArea, {
    onClick: function onClick() {
      return setConfirmDelete(true);
    }
  }, /*#__PURE__*/React.createElement(StyledDeleteIcon, null, /*#__PURE__*/React.createElement(DeleteIcon, null)))), droppedFile && /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: function onClose() {
      return setOpen(false);
    },
    fullWidth: true,
    maxWidth: "lg"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    onClose: function onClose() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React.createElement("span", null, "\xA0")), /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement(AvatarCropDialog, _extends({
    droppedFile: droppedFile
  }, rest, {
    onSave: handleSave,
    onDelete: handleDelete
  })))), /*#__PURE__*/React.createElement(Confirmation, {
    open: confirmDelete,
    onCancel: function onCancel() {
      return setConfirmDelete(false);
    },
    onConfirm: handleDelete,
    message: "Are you sure you want to remove the attached image?"
  }));
};
AvatarInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * Text label displayed in the dropzone
   */
  dropzoneLabel: PropTypes.string,
  /**
   * Text description displayed in the dropzone
   */
  dropzoneDescription: PropTypes.any,
  /**
   * Icon displayed in the dropzone
   */
  DropzoneIcon: PropTypes.any,
  /**
   * URL for default/placeholder image.
   */
  placeholder: PropTypes.string,
  /**
   * URL for current image.
   */
  value: PropTypes.string,
  /**
   * Make button edges rounded or square
   */
  edges: PropTypes.oneOf(['normal', 'rounded', 'sharp']),
  /**
   * Do something when user saves cropped image, received the base64 string
   */
  onSave: PropTypes.func,
  /**
   * Do something when user removes image
   */
  onDelete: PropTypes.func,
  /**
   * If `true`, represents the file(s) has been selected
   */
  hasSelection: PropTypes.bool
} : {};
AvatarInput.defaultProps = {
  disabled: false,
  dropzoneLabel: 'Upload file',
  dropzoneDescription: 'Drag and drop a file here, or click to select a file',
  edges: 'normal',
  placeholder: 'https://via.placeholder.com/500x300',
  value: '',
  onSave: function onSave() {
    return Promise.resolve(true);
  },
  onDelete: function onDelete() {
    return Promise.resolve(true);
  },
  DropzoneIcon: null,
  hasSelection: false
};
export default AvatarInput;